import { IModuleConfig, MenuKind } from '@simac/ui';
import { FieldAddRoute } from '../field-add/field-add.routes';
import { FieldRetourRoute } from '../field-retour/field-retour.routes';
import { FieldWorkspaceRoute } from '../field-workspace/field-workspace.routes';
import { InboundRoute } from '../inbound/inbound.routes';
import { OrderpickingRoute } from '../orderpicking/orderpicking.routes';
import { OutboundRoute } from '../outbound/outbound.routes';
import { RetourRoute } from '../retour/retour.routes';
import { ScanRoute } from '../scan/scan.routes';
import { SerialnumberRoute } from '../serialnumber/serialnumber.routes';
import { StagingRoute } from '../staging/staging.routes';
import { StockRoute } from '../stock/stock.routes';

export const FieldSupportModuleConfig: IModuleConfig = {
  name: 'fieldsupport',
  injects: [
    {
      name: 'projectmanagement',
      components: [
        {
          name: 'Limit engineer management',
          icon: 'far fa-user-gear',
          translateLabel: 'FIELDSUPPORT.MANAGEMENT.LIMITENGINEER',
          permission: 'Module.FieldSupport.LimitEngineerManagement.View',
          pages: [
            {
              isDefault: true,
              route: 'limit-engineer-management',
              loadComponent: () => import('../projectmanagement/limit-engineer/pages/limit-engineer-management.component').then((m) => m.LimitEngineerManagementComponent),
            },
          ],
        },
      ],
    },
  ],
  routing: {
    menuKind: MenuKind.Main,
    route: 'fieldsupport',
    children: [
      {
        title: 'MENU.FIELDSUPPORT.SCAN',
        route: ScanRoute,
        permission: 'Module.FieldSupport.Scan',
        icon: 'far fa-scanner',
      },
      {
        title: 'MENU.FIELDSUPPORT.FIELD-ADD',
        route: FieldAddRoute,
        permission: 'Module.FieldSupport.FieldAdd',
        icon: 'far fa-plus',
      },
      {
        title: 'MENU.FIELDSUPPORT.FIELD-RETOUR',
        children: FieldRetourRoute,
        permission: 'Module.FieldSupport.FieldRetour',
        icon: 'far fa-swap',
      },
      {
        title: 'MENU.FIELDSUPPORT.FIELD-WORKSPACE',
        route: FieldWorkspaceRoute,
        permission: 'Module.FieldSupport.FieldWorkspace',
        icon: 'far fa-computer',
      },
      {
        title: 'MENU.FIELDSUPPORT.STOCK',
        route: StockRoute,
        permission: 'Module.FieldSupport.Stock.View',
        icon: 'far fa-shelves',
      },
      {
        title: 'MENU.FIELDSUPPORT.INBOUND',
        route: InboundRoute,
        permission: 'Module.FieldSupport.Inbound',
        icon: 'far fa-inbox-in',
      },
      {
        title: 'MENU.FIELDSUPPORT.ORDERPICKING',
        children: OrderpickingRoute,
        permission: 'Module.FieldSupport.Orderpicking',
        icon: 'far fa-boxes-packing',
      },
      {
        title: 'MENU.FIELDSUPPORT.STAGING',
        children: StagingRoute,
        permission: 'Module.FieldSupport.Staging',
        icon: 'far fa-sign-posts-wrench',
      },
      {
        title: 'MENU.FIELDSUPPORT.OUTBOUND',
        children: OutboundRoute,
        permission: 'Module.FieldSupport.Outbound',
        icon: 'far fa-truck-container',
      },
      {
        title: 'MENU.FIELDSUPPORT.RETOUR',
        children: RetourRoute,
        permission: 'Module.FieldSupport.Retour',
        icon: 'far fa-helmet-safety',
      },
      {
        title: 'MENU.FIELDSUPPORT.SERIALNUMBER',
        route: SerialnumberRoute,
        permission: 'Module.FieldSupport.Asset.LinkSerial',
        icon: 'far fa-link',
      },
    ],
  },
  breadCrumb: {
    stock: [
      { key: 'fieldsupport', label: '', hide: true },
      { key: 'page', label: 'MENU.FIELDSUPPORT.STOCK' },
      { key: 'stock', label: '' },
    ],
  },
};
